const Config = {
  siteName: '19hz.info',
  siteUrl: 'https://20hz.netlify.app',
  importUrl: 'https://19hz.info',
  siteTitle: 'electronic music calendars',
  regions: [
    {
      id: 0,
      name: 'San Francisco',
      name2: 'Bay Area',
      slug: 'sanfrancisco',
      import: 'BayArea',
      filters: ['San Francisco', 'Oakland', 'San Jose', 'Sacramento'],
      description:
        'Events surrounding the San Francisco Bay Area in Southern California.',
    },
    {
      id: 1,
      name: 'Los Angeles',
      name2: 'Southern California',
      slug: 'losangeles',
      import: 'LosAngeles',
      filters: ['Los Angeles', 'San Diego'],
      description: 'Events surrounding Los Angeles in Southern California.',
    },
    {
      id: 2,
      name: 'Texas',
      slug: 'texas',
      import: 'Texas',
      filters: ['Austin', 'Dallas', 'Houston', 'San Antonio', 'El Paso'],
      description: 'Events in the state of Texas.',
    },
    {
      id: 3,
      name: 'Atlanta',
      slug: 'atlanta',
      import: 'Atlanta',
      filters: ['Atlanta'],
      description: 'Events in Atlanda, Georgia.',
    },
    {
      id: 4,
      name: 'Florida',
      name2: 'Miami, Orlando, Tampa',
      slug: 'florida',
      import: 'Miami',
      filters: ['Miami', 'Orlando', 'Tampa', 'Jacksonville'],
      description: 'Events in Southern Florida.',
    },
    {
      id: 5,
      name: 'Phoenix',
      slug: 'phoenix',
      import: 'Phoenix',
      filters: ['Phoenix'],
      description: 'Events surrounding Phoenix, Arizona. ',
    },
    {
      id: 6,
      name: 'Chicago',
      slug: 'chicago',
      import: 'CHI',
      filters: ['Chicago'],
      description: 'Events in the greater Chicagoland area.',
    },
    {
      id: 7,
      name: 'Iowa',
      slug: 'iowa',
      import: 'Iowa',
      filters: ['Cedar Rapids'],
      description: 'Events in the state of Iowa.',
    },
    {
      id: 8,
      name: 'PNW',
      name2: 'Portland, Seattle, Vancouver',
      slug: 'cregon',
      import: 'PNW',
      filters: ['Portland', 'Seattle', 'Vancouver'],
      description: 'Events surrounding the Pacific Northwest.',
    },
    {
      id: 9,
      name: 'Washington, DC',
      slug: 'dc',
      import: 'DC',
      filters: ['DC'],
      description: 'Events surrounding the DC metro area.',
    },
    {
      id: 10,
      name: 'Massachusetts',
      slug: 'massachusetts',
      import: 'Massachusetts',
      filters: ['Boston', 'Cambridge'],
      description: 'Events in the stete of Massachusetts.',
    },
  ],
};

export default Config;
